import { PropertySellabilityRank } from '../property/types';

export const mapPropertySellabilityRankToColor: Record<PropertySellabilityRank, string> = {
  [PropertySellabilityRank.LOW]: '#E56675',
  [PropertySellabilityRank.MEDIUM]: '#FF7F00',
  [PropertySellabilityRank.HIGH]: '#009686',
  [PropertySellabilityRank.HIGHEST]: '#005F54',
};
